import { getConfig, getEnvironmentBranding } from "../config";

const TOKEN_STORAGE_KEY = "user:token";
const E2E_TOKEN_ISSUER = "whitecube-e2e";

const readTokenIssuer = token => {
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(payload)).iss ?? null;
  } catch {
    return null;
  }
};

// Playwright signs in with a token the local API accepts in place of a
// Microsoft one. Only honoured against a local API; the API checks it too.
const isE2eSignInEnabled = ({
  flag = getConfig("REACT_APP_E2E_AUTH"),
  environmentName = getEnvironmentBranding().name,
} = {}) => flag === "true" && environmentName === "local";

// Microsoft tokens share the storage key, so only tokens issued for E2E count.
const readE2eToken = (storage = localStorage) => {
  const token = storage.getItem(TOKEN_STORAGE_KEY);
  return token && readTokenIssuer(token) === E2E_TOKEN_ISSUER ? token : null;
};

const hasE2eSession = () => isE2eSignInEnabled() && Boolean(readE2eToken());

// An E2E token cannot be renewed, so a rejected one is dropped and the app
// reloads to the sign-in page instead of retrying forever.
const clearE2eToken = async (storage = localStorage) => {
  storage.removeItem(TOKEN_STORAGE_KEY);
  return null;
};

export { clearE2eToken, hasE2eSession, isE2eSignInEnabled, readE2eToken };
